//imports needed for this function
const axios = require('axios');

export async function pinJSONToIPFS(JSONBody) {
  const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

  return axios
    .post(url, JSONBody, {
      headers: {
        pinata_api_key: process.env.REACT_APP_L,
        pinata_secret_api_key: process.env.REACT_APP_K
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.error("Error during JSON upload to IPFS")
      return error;
    });
};